// Pages shown with no session: the app must not call GET /platform/me for them (the sign-in
// outcome page is where the BFF sends people back after a failed sign-in or a sign-out).
const PUBLIC_PATHS: readonly RegExp[] = [/^\/signed-out\/?$/];

/** Whether `path` (an address path, with or without a query string) is a public page. */
export function isPublicPath(path: string): boolean {
  const pathname = path.split(/[?#]/)[0] ?? path;
  return PUBLIC_PATHS.some((pattern) => pattern.test(pathname));
}
